import { Component, OnInit } from '@angular/core';
import { AppService } from 'src/app/app.service';

@Component({
    selector: 'app-tabitapp-banner',
    templateUrl: './tabitapp-banner.component.html',
    styleUrls: ['./tabitapp-banner.component.scss'],
    standalone: false
})
export class TabitappBannerComponent implements OnInit {

	constructor(
		public appService: AppService
	) { }

	displayBanner: boolean;
	storeIcon: string;
	storeLink: string;

	navigateToStore = function () {
		if (navigator && /android/i.test(navigator.userAgent)) {
			window.open('https://play.google.com/store/apps/details?id=app.tabit.il_prd', '_blank');
		} else {
			window.open('https://apps.apple.com/il/app/tabit-%D7%98%D7%90%D7%91%D7%99%D7%98/id1463575038','_blank');
		}
	};

	closeAndMarkAsWatched = function () {
		this.appService.showAppBanner = false;
	};

	ngOnInit() {
		if (navigator && /android/i.test(navigator.userAgent)) {
			this.storeIcon = '/assets/images/google-play.svg';
		} else {
			this.storeIcon = '/assets/images/apple-app-store.svg';
		}
	}

}
